angular.module('bizmetryApp')
  .controller('ImportResourceInstanceDialogController', [
    '$scope',
    '$mdDialog',
    '$mdToast',
    'dialogService',
    'profile',
    'resourceTypes',
    'environments',
    'DatasourceService',
    'ResourceService',
    'TemplateInstanceService',
    'ConfigurationService',
    function ($scope, $mdDialog, $mdToast, dialogService, profile, resourceTypes, environments,
      DatasourceService, ResourceService, TemplateInstanceService, ConfigurationService) {

      // =====================================================
      // INITIALIZATION
      // =====================================================

      var vm = this;

      vm.profile = profile;

      vm.templateInstance = null;
      vm.loadingTemplateInstance = false;

      vm.importData = {
        selectedEnvironmentId:  null,
        selectedResourceTypeId: null,
        selectedRecords: []
      };

      vm.isImporting = false;
      vm.allResourceTypes = resourceTypes || [];
      vm.allEnvironments  = environments  || [];

      vm.filteredEnvironments  = [];
      vm.filteredResourceTypes = [];

      vm.datasources    = [];
      vm.datasourcesById = {};
      vm.loadingDatasources = true;

      vm.existingPKs  = [];
      vm.loadingPKs   = false;

      console.log('[ImportResourcesDialog] Initialized with:', {
        totalResourceTypes: vm.allResourceTypes.length,
        totalEnvironments:  vm.allEnvironments.length,
        profileEnvironments: (profile.environments || []).length
      });

      loadDatasources();
      filterValidEnvironments();

      // =====================================================
      // FILTER VALID ENVIRONMENTS
      // =====================================================

      function filterValidEnvironments() {
        var profileEnvs = profile.environments || [];

        vm.filteredEnvironments = profileEnvs.filter(function (env) {
          if (env.agent_status !== 'ONLINE') {
            console.log('[ImportResourcesDialog] Env "' + env.name + '" excluded: agent offline (' + env.agent_status + ')');
            return false;
          }
          if (!env.templateInstanceId) {
            console.log('[ImportResourcesDialog] Env "' + env.name + '" excluded: no templateInstanceId');
            return false;
          }
          if (env.templateInstanceStatus !== 'PUBLISHED') {
            console.log('[ImportResourcesDialog] Env "' + env.name + '" excluded: template not published (' + env.templateInstanceStatus + ')');
            return false;
          }
          return true;
        });

        console.log('[ImportResourcesDialog] Valid environments for import:', {
          total: profileEnvs.length,
          valid: vm.filteredEnvironments.length,
          names: vm.filteredEnvironments.map(function (e) {
            return e.name + ' (v' + e.templateInstanceVersion + ', agent: ' + e.agent_status + ')';
          })
        });
      }

      // =====================================================
      // LOAD DATASOURCES
      // =====================================================

      function loadDatasources() {
        vm.loadingDatasources = true;

        DatasourceService.getDatasources(profile.id)
          .then(function (datasources) {
            vm.datasources     = datasources || [];
            vm.datasourcesById = {};
            vm.datasources.forEach(function (ds) {
              vm.datasourcesById[ds.id] = ds;
            });
            console.log('✅ [ImportResourcesDialog] Datasources loaded:', vm.datasources.length);
          })
          .catch(function (error) {
            console.error('❌ [ImportResourcesDialog] Error loading datasources:', error);
            $mdToast.show(
              $mdToast.simple()
                .textContent('Warning: Could not load datasource status')
                .position('top right')
                .hideDelay(3000)
            );
          })
          .finally(function () {
            vm.loadingDatasources = false;
          });
      }

      // =====================================================
      // LOAD TEMPLATE INSTANCE FOR SELECTED ENVIRONMENT
      // =====================================================

      function loadTemplateInstanceForEnvironment(environmentId) {
        if (!environmentId) {
          vm.templateInstance      = null;
          vm.filteredResourceTypes = [];
          vm.importData.selectedResourceTypeId = null;
          return;
        }

        var profileEnv = (profile.environments || []).find(function (e) {
          return e.id === environmentId;
        });

        if (!profileEnv || !profileEnv.templateInstanceId) {
          console.error('[ImportResourcesDialog] No templateInstanceId found for environment:', environmentId);
          vm.templateInstance      = null;
          vm.filteredResourceTypes = [];
          return;
        }

        vm.loadingTemplateInstance = true;
        vm.templateInstance        = null;
        vm.filteredResourceTypes   = [];
        vm.importData.selectedResourceTypeId = null;
        vm.importData.selectedRecords        = [];

        console.log('🔍 [ImportResourcesDialog] Loading templateInstance:', profileEnv.templateInstanceId,
          'for environment:', profileEnv.name, '(v' + profileEnv.templateInstanceVersion + ')');

        TemplateInstanceService.getTemplateInstanceById(profileEnv.templateInstanceId)
          .then(function (response) {
            var templateInstance = response.data;

            if (!templateInstance) {
              console.warn('[ImportResourcesDialog] No templateInstance returned');
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Could not load template configuration for this environment')
                  .position('top right')
                  .hideDelay(4000)
              );
              return;
            }

            vm.templateInstance = templateInstance;
            console.log('✅ [ImportResourcesDialog] TemplateInstance loaded:', {
              id:      templateInstance.id,
              status:  templateInstance.templateStatus,
              version: profileEnv.templateInstanceVersion
            });

            filterResourceTypes(environmentId);
          })
          .catch(function (error) {
            console.error('❌ [ImportResourcesDialog] Error loading templateInstance:', error);
            vm.templateInstance      = null;
            vm.filteredResourceTypes = [];

            $mdToast.show(
              $mdToast.simple()
                .textContent('Error loading template configuration. Please try again.')
                .position('top right')
                .hideDelay(4000)
            );
          })
          .finally(function () {
            vm.loadingTemplateInstance = false;
          });
      }

      // =====================================================
      // FILTER RESOURCE TYPES
      // =====================================================

      function filterResourceTypes(environmentId) {
        vm.filteredResourceTypes = [];

        if (!vm.templateInstance) {
          console.warn('[ImportResourcesDialog] No templateInstance loaded');
          return;
        }

        try {
          var templateConfig = vm.templateInstance.templateConfig;

          if (!templateConfig || !templateConfig.resource_types) {
            console.warn('[ImportResourcesDialog] No resource_types in templateConfig');
            return;
          }

          if (!templateConfig.attribute_types || !Array.isArray(templateConfig.attribute_types)) {
            console.warn('[ImportResourcesDialog] No attribute_types in templateConfig');
            return;
          }

          vm.filteredResourceTypes = templateConfig.resource_types
            .filter(function (rtConfig) {
              if (!rtConfig.is_resource_imported) return false;

              var hasResourceNameField = templateConfig.attribute_types.some(function (attr) {
                return attr.resource_id === rtConfig.id && attr.isResourceNameField === true;
              });
              if (!hasResourceNameField) {
                console.log('[ImportResourcesDialog] RT "' + rtConfig.name + '" excluded: no isResourceNameField');
                return false;
              }

              if (environmentId) {
                var envMappings = rtConfig.env_mappings || [];
                var envMapping  = envMappings.find(function (m) {
                  return m.env_id === environmentId && !m.markedForDeletion;
                });

                if (!envMapping) {
                  console.log('[ImportResourcesDialog] RT "' + rtConfig.name + '" excluded: no envMapping for environment');
                  return false;
                }
                if (!envMapping.datasource_id) {
                  console.log('[ImportResourcesDialog] RT "' + rtConfig.name + '" excluded: no datasource_id');
                  return false;
                }

                var datasource = vm.datasourcesById[envMapping.datasource_id];
                if (!datasource) {
                  console.log('[ImportResourcesDialog] RT "' + rtConfig.name + '" excluded: datasource not found');
                  return false;
                }
                if (!datasource.isOnline) {
                  console.log('[ImportResourcesDialog] RT "' + rtConfig.name + '" excluded: datasource offline');
                  return false;
                }
              }

              return true;
            })
            .map(function (rtConfig) {
              var fullResourceType = vm.allResourceTypes.find(function (rt) {
                return rt.id === rtConfig.id;
              });

              var resourceNameAttr = templateConfig.attribute_types.find(function (attr) {
                return attr.resource_id === rtConfig.id && attr.isResourceNameField === true;
              });

              return {
                id:                       rtConfig.id,
                name:                     fullResourceType ? fullResourceType.name : rtConfig.name || 'Unknown',
                resourceNameAttributeId:  resourceNameAttr ? resourceNameAttr.id : null,
                resourceNameAttributeName: resourceNameAttr ? resourceNameAttr.name : null,
                resourceNameColumn:       resourceNameAttr ? resourceNameAttr.column_metadata_name : null,
                isImportedFromDb:         true,
                envMappings:              rtConfig.env_mappings || []
              };
            });

        } catch (error) {
          console.error('[ImportResourcesDialog] Error filtering resource types:', error);
        }

        console.log('[ImportResourcesDialog] Filtered resource types for environment:', {
          environmentId: environmentId,
          total:         vm.allResourceTypes.length,
          filtered:      vm.filteredResourceTypes.length,
          types: vm.filteredResourceTypes.map(function (rt) {
            return rt.name + ' (resourceName: ' + rt.resourceNameAttributeName + ')';
          })
        });
      }

      // =====================================================
      // WATCHERS
      // =====================================================

      $scope.$watch('vm.importData.selectedEnvironmentId', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          console.log('[ImportResourcesDialog] Environment changed:', { from: oldValue, to: newValue });
          vm.importData.selectedResourceTypeId = null;
          vm.importData.selectedRecords        = [];
          vm.existingPKs                       = [];
          vm.templateInstance                  = null;
          vm.filteredResourceTypes             = [];
          if (newValue) { loadTemplateInstanceForEnvironment(newValue); }
        }
      });

      $scope.$watch('vm.importData.selectedResourceTypeId', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          console.log('[ImportResourcesDialog] Resource type changed:', { from: oldValue, to: newValue });
          vm.importData.selectedRecords = [];
          vm.existingPKs               = [];
          if (newValue) { loadExistingPKs(); }
        }
      });

      // =====================================================
      // LOAD EXISTING PKs
      // =====================================================

      function loadExistingPKs() {
        if (!vm.importData.selectedResourceTypeId || !vm.importData.selectedEnvironmentId) {
          vm.existingPKs = [];
          return;
        }

        vm.loadingPKs  = true;
        vm.existingPKs = [];

        ResourceService.getResourcePKs(
          vm.profile.id,
          vm.importData.selectedEnvironmentId,
          vm.importData.selectedResourceTypeId
        )
          .then(function (response) {
            vm.existingPKs = response.data.pks || [];
            console.log('✅ [ImportResourcesDialog] Loaded existing PKs:', vm.existingPKs.length);
          })
          .catch(function (error) {
            console.error('❌ [ImportResourcesDialog] Error loading existing PKs:', error);
            vm.existingPKs = [];
          })
          .finally(function () {
            vm.loadingPKs = false;
          });
      }

      // =====================================================
      // HELPER METHODS — Environment / ResourceType / Datasource
      // =====================================================

      vm.getResourceTypeName = function (id) {
        var rt = vm.filteredResourceTypes.find(function (rt) { return rt.id === id; });
        return rt ? rt.name : '';
      };

      vm.getEnvironmentName = function (id) {
        var env = vm.allEnvironments.find(function (env) { return env.id === id; });
        return env ? env.name : '';
      };

      vm.getTemplateVersion = function () {
        if (!vm.importData.selectedEnvironmentId) return null;
        var profileEnv = (profile.environments || []).find(function (e) {
          return e.id === vm.importData.selectedEnvironmentId;
        });
        return profileEnv ? profileEnv.templateInstanceVersion : null;
      };

      /**
       * Devuelve el env_mapping del resource type seleccionado para el ambiente seleccionado.
       * Usado en el summary para mostrar schema.table.
       */
      vm.getSelectedEnvMapping = function () {
        if (!vm.importData.selectedResourceTypeId || !vm.importData.selectedEnvironmentId) return null;

        var rt = vm.filteredResourceTypes.find(function (rt) {
          return rt.id === vm.importData.selectedResourceTypeId;
        });
        if (!rt) return null;

        return (rt.envMappings || []).find(function (m) {
          return m.env_id === vm.importData.selectedEnvironmentId && !m.markedForDeletion;
        }) || null;
      };

      /**
       * Devuelve el objeto datasource para el resource type + ambiente seleccionados.
       * Usado en el summary para mostrar nombre del datasource y su estado online.
       */
      vm.getSelectedDatasource = function () {
        var envMapping = vm.getSelectedEnvMapping();
        if (!envMapping || !envMapping.datasource_id) return null;
        console.log ('vm.getSelectedDataSource =>', vm.datasourcesById[envMapping.datasource_id]);
        return vm.datasourcesById[envMapping.datasource_id] || null;
      };

      // =====================================================
      // VALIDATION
      // =====================================================

      vm.canSelectData = function () {
        return vm.importData.selectedEnvironmentId &&
               vm.importData.selectedResourceTypeId &&
               vm.templateInstance !== null &&
               !vm.loadingTemplateInstance;
      };

      vm.canImport = function () {
        return vm.importData.selectedRecords && vm.importData.selectedRecords.length > 0;
      };

      vm.getSelectedRecordsCount = function () {
        return vm.importData.selectedRecords ? vm.importData.selectedRecords.length : 0;
      };

      // =====================================================
      // JSON PATH EVALUATION
      // =====================================================

      function evaluateJsonPath(obj, path) {
        if (!obj || typeof obj !== 'object') { return undefined; }
        if (!path || typeof path !== 'string') { return undefined; }

        try {
          if (typeof JSONPath === 'undefined' || typeof JSONPath.JSONPath !== 'function') {
            console.error('[evaluateJsonPath] ❌ JSONPath library not loaded!');
            return undefined;
          }

          var jsonPathQuery = path.startsWith('$') ? path : '$.' + path;
          var result = JSONPath.JSONPath({ path: jsonPathQuery, json: obj, wrap: false });

          if (result === undefined || result === null) return undefined;
          if (Array.isArray(result) && result.length === 0) return undefined;
          if (Array.isArray(result) && result.length === 1) result = result[0];
          return result;
        } catch (error) {
          console.error('[evaluateJsonPath] ❌ Error evaluating path:', path, error);
          return undefined;
        }
      }

      vm.extractResourceName = function (record, resourceType) {
        if (!record || !record.fullRowData) return null;

        var rnAttribute = null;
        if (vm.templateInstance && vm.templateInstance.templateConfig) {
          var attrs = vm.templateInstance.templateConfig.attribute_types || [];
          rnAttribute = attrs.find(function (attr) {
            return attr.resource_id === resourceType.id && attr.isResourceNameField === true;
          });
        }
        if (!rnAttribute) return null;

        if (rnAttribute.resourceNameJsonPath) {
          var jsonFieldValue = record.fullRowData[rnAttribute.column_metadata_name];
          if (!jsonFieldValue) return null;
          var jsonData = jsonFieldValue;
          if (typeof jsonFieldValue === 'string') {
            try { jsonData = JSON.parse(jsonFieldValue); } catch (e) { return null; }
          }
          return evaluateJsonPath(jsonData, rnAttribute.resourceNameJsonPath);
        }
        return record.fullRowData[rnAttribute.column_metadata_name];
      };

      vm.extractResourceDescription = function (record, resourceType) {
        if (!record || !record.fullRowData) return null;

        var rdAttribute = null;
        if (vm.templateInstance && vm.templateInstance.templateConfig) {
          var attrs = vm.templateInstance.templateConfig.attribute_types || [];
          rdAttribute = attrs.find(function (attr) {
            return attr.resource_id === resourceType.id && attr.isResourceDescriptionField === true;
          });
        }
        if (!rdAttribute) return null;

        if (rdAttribute.resourceDescriptionJsonPath) {
          var jsonFieldValue = record.fullRowData[rdAttribute.column_metadata_name];
          if (!jsonFieldValue) return null;
          var jsonData = jsonFieldValue;
          if (typeof jsonFieldValue === 'string') {
            try { jsonData = JSON.parse(jsonFieldValue); } catch (e) { return null; }
          }
          return evaluateJsonPath(jsonData, rdAttribute.resourceDescriptionJsonPath);
        }
        return record.fullRowData[rdAttribute.column_metadata_name];
      };

      // =====================================================
      // OPEN DATA SELECTION DIALOG
      // =====================================================

      vm.openDataSelectionDialog = function () {
        if (!vm.canSelectData()) {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title('Missing Information')
              .textContent('Please select both an Environment and a Resource Type before selecting data to import.')
              .ok('OK')
          );
          return;
        }

        var selectedResourceType = vm.filteredResourceTypes.find(function (rt) {
          return rt.id === vm.importData.selectedResourceTypeId;
        });
        if (!selectedResourceType) {
          dialogService.showErrorDialog('Configuration Error', 'Selected resource type not found.');
          return;
        }

        var selectedEnvironment = vm.filteredEnvironments.find(function (env) {
          return env.id === vm.importData.selectedEnvironmentId;
        });
        if (!selectedEnvironment) {
          dialogService.showErrorDialog('Configuration Error', 'Selected environment not found.');
          return;
        }

        var envMapping = vm.getSelectedEnvMapping();
        if (!envMapping) {
          dialogService.showErrorDialog(
            'Configuration Error',
            'No database mapping found for the selected environment and resource type.'
          );
          return;
        }

        var templateJson    = vm.templateInstance.templateConfig;
        var pkAttributes    = templateJson.attribute_types
          .filter(function (attr) {
            return attr.resource_id === vm.importData.selectedResourceTypeId && attr.isPrimaryKey === true;
          })
          .map(function (attr) {
            return {
              id:                   attr.id,
              name:                 attr.name,
              column_name:          attr.column_metadata_name || attr.name,
              column_metadata_name: attr.column_metadata_name,
              description:          attr.description || '',
              isPrimaryKey:         true
            };
          });

        if (pkAttributes.length === 0) {
          dialogService.showErrorDialog(
            'Configuration Error',
            'No primary key attributes found for the selected resource type.'
          );
          return;
        }

        var resourceAttributes = templateJson.attribute_types
          .filter(function (attr) {
            return attr.resource_id === vm.importData.selectedResourceTypeId;
          })
          .map(function (attr) {
            return {
              id:                          attr.id,
              name:                        attr.name,
              column_metadata_name:        attr.column_metadata_name,
              description:                 attr.description || '',
              scalar_attribute_type:       attr.scalar_attribute_type || 'STRING',
              isPrimaryKey:                attr.isPrimaryKey || false,
              isResourceNameField:         attr.isResourceNameField || false,
              isResourceDescriptionField:  attr.isResourceDescriptionField || false,
              isSensitive:                 attr.isSensitive || false,
              lower_bound:                 attr.lower_bound,
              upper_bound:                 attr.upper_bound,
              jsonSchema:                  attr.jsonSchema,
              jsonSample:                  attr.jsonSample,
              resourceNameJsonPath:        attr.resourceNameJsonPath,
              resourceDescriptionJsonPath: attr.resourceDescriptionJsonPath
            };
          });

        if (resourceAttributes.length === 0) {
          dialogService.showErrorDialog(
            'Configuration Error',
            'No attributes found for the selected resource type.'
          );
          return;
        }

        console.log('[ImportResourcesDialog] Opening database picker with:', {
          resourceType:       selectedResourceType.name,
          environment:        selectedEnvironment.name,
          envMapping:         envMapping,
          pkAttributes:       pkAttributes.length,
          resourceAttributes: resourceAttributes.length,
          existingPKs:        vm.existingPKs.length
        });

        $mdDialog.show({
          controller:         'DatabasePickerDialogController',
          controllerAs:       'vm',
          templateUrl:        'profile/tabs/resources/database-picker/database-picker-dialog.html',
          parent:             angular.element(document.body),
          clickOutsideToClose: false,
          multiple:           true,
          locals: {
            envMapping:         envMapping,
            pkAttributes:       pkAttributes,
            environment:        selectedEnvironment,
            resourceAttributes: resourceAttributes,
            // Max records per import round — central-config (bizmetry-shared): frontend.resources.import_max_records
            maxSelections:      ConfigurationService.getFromCache('frontend.resources.import_max_records') || 4096,
            existingPKs:        vm.existingPKs
          }
        }).then(function (selectedRecords) {
          if (!selectedRecords || selectedRecords.length === 0) {
            console.log('[ImportResourcesDialog] No records selected');
            return;
          }
          console.log('[ImportResourcesDialog] Selected records:', selectedRecords.length);
          vm.importData.selectedRecords = selectedRecords;

          $mdToast.show(
            $mdToast.simple()
              .textContent(selectedRecords.length + ' record(s) selected for import')
              .position('top right')
              .hideDelay(3000)
          );
        }).catch(function (error) {
          if (error !== 'user_cancelled' && error !== 'cancel') {
            console.error('[ImportResourcesDialog] Error selecting data:', error);
          }
        });
      };

      // =====================================================
      // PROCEED WITH IMPORT
      // =====================================================

      vm.proceedWithImport = function () {
        if (!vm.importData.selectedRecords || vm.importData.selectedRecords.length === 0) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Please select records to import')
              .position('top right')
              .hideDelay(3000)
          );
          return;
        }
        if (vm.isImporting) return;

        vm.isImporting = true;

        var selectedResourceType = vm.filteredResourceTypes.find(function (rt) {
          return rt.id === vm.importData.selectedResourceTypeId;
        });
        if (!selectedResourceType) {
          vm.isImporting = false;
          dialogService.showErrorDialog('Configuration Error', 'Selected resource type not found.');
          return;
        }

        var selectedEnvironment = vm.filteredEnvironments.find(function (env) {
          return env.id === vm.importData.selectedEnvironmentId;
        });
        if (!selectedEnvironment) {
          vm.isImporting = false;
          dialogService.showErrorDialog('Configuration Error', 'Selected environment not found.');
          return;
        }

        var primaryKeyAttribute = null;
        if (vm.templateInstance && vm.templateInstance.templateConfig) {
          var attrs = vm.templateInstance.templateConfig.attribute_types || [];
          primaryKeyAttribute = attrs.find(function (attr) {
            return attr.resource_id === vm.importData.selectedResourceTypeId && attr.isPrimaryKey === true;
          });
        }
        if (!primaryKeyAttribute) {
          vm.isImporting = false;
          dialogService.showErrorDialog(
            'Configuration Error',
            'Primary key attribute not found for the selected resource type.'
          );
          return;
        }

        // Only the primary keys travel: resource-ms pulls each full row from the agent and takes
        // the name/description (and the stored source record) from it. Smaller body, and no
        // free text for the edge WAF to inspect.
        var resources = vm.importData.selectedRecords.map(function (record) {
          var resourceId = null;
          if (record.primaryKeys && record.primaryKeys.length > 0) {
            resourceId = record.primaryKeys[0].attributeValue;
          }
          return { id: resourceId };
        });

        var validResources = resources.filter(function (r) {
          return r.id !== null && r.id !== undefined;
        });

        if (validResources.length === 0) {
          vm.isImporting = false;
          dialogService.showErrorDialog(
            'Import Error',
            'Could not extract primary key values from selected records. Please check the resource type configuration.'
          );
          return;
        }

        var importPayload = {
          accountId:   vm.profile.accountId,
          profileId:   vm.profile.id,
          environment: {
            id:   vm.importData.selectedEnvironmentId,
            name: selectedEnvironment.name
          },
          resourceType: selectedResourceType,
          primaryKey: {
            attributeId:   primaryKeyAttribute.id,
            attributeName: primaryKeyAttribute.name
          },
          resources: validResources
        };

        console.log('[ImportResourcesDialog] Import payload:', importPayload);

        // Sent in sequential batches: one request with thousands of records
        // can exceed the edge WAF body limit (SecRequestBodyNoFilesLimit ~2.2MB)
        // and the backend import transaction time. Each batch is atomic on the
        // backend; counts are aggregated across batches.
        // central-config (bizmetry-shared): frontend.resources.import_batch_size
        var batchSize = ConfigurationService.getFromCache('frontend.resources.import_batch_size') || 1024;
        var batches = [];
        for (var b = 0; b < validResources.length; b += batchSize) {
          batches.push(validResources.slice(b, b + batchSize));
        }
        var totals = { totalProcessed: 0, created: 0, updated: 0, responses: [] };
        vm.importProgress = { done: 0, total: batches.length };

        // Up to N batches in flight (each is atomic on the backend). After a failure no new batch
        // starts; the ones in flight finish, then the error is reported.
        // central-config (bizmetry-shared): frontend.resources.import_concurrency
        var concurrency = Math.max(1, ConfigurationService.getFromCache('frontend.resources.import_concurrency') || 3);
        var nextBatch = 0;
        var firstError = null;

        function importWorker() {
          if (firstError || nextBatch >= batches.length) { return Promise.resolve(); }
          var batchPayload = angular.extend({}, importPayload, { resources: batches[nextBatch++] });
          return Promise.resolve(ResourceService.importResources(vm.profile.id, batchPayload))
            .then(function (response) {
              var data = (response && response.data) || {};
              totals.totalProcessed += data.totalProcessed || 0;
              totals.created        += data.created        || 0;
              totals.updated        += data.updated        || 0;
              totals.responses.push(data);
              vm.importProgress.done++;
              return importWorker();
            }, function (error) {
              firstError = firstError || error;
            });
        }

        var workers = [];
        for (var w = 0; w < Math.min(concurrency, batches.length); w++) { workers.push(importWorker()); }
        var chain = Promise.all(workers).then(function () {
          if (firstError) { throw firstError; }
        });

        chain
          .then(function () {
            $scope.$applyAsync(function () {
              vm.isImporting = false;

              var message = totals.totalProcessed + ' resource(s) processed';
              if (totals.created > 0 && totals.updated > 0) { message = totals.created + ' created, ' + totals.updated + ' updated'; }
              else if (totals.created > 0)                  { message = totals.created + ' resource(s) created'; }
              else if (totals.updated > 0)                  { message = totals.updated + ' resource(s) updated'; }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(message)
                  .position('top right')
                  .hideDelay(3000)
              );

              $mdDialog.hide({
                success:        true,
                totalProcessed: totals.totalProcessed,
                created:        totals.created,
                updated:        totals.updated,
                response:       totals.responses.length === 1 ? totals.responses[0] : totals.responses
              });
            });
          })
          .catch(function (error) {
            console.error('[ImportResourcesDialog] ❌ Import failed:', error);
            $scope.$applyAsync(function () {
              vm.isImporting = false;

              var errorMessage = 'Failed to import resources. Please try again.';
              if (error && error.data && error.data.message) {
                errorMessage = error.data.message;
              } else if (error && error.statusText) {
                errorMessage = 'Import failed: ' + error.statusText;
              }
              // Earlier batches are already committed — say so explicitly.
              if (vm.importProgress.done > 0) {
                errorMessage += '\n\n' + vm.importProgress.done + ' of ' + vm.importProgress.total +
                  ' batch(es) were already imported (' + totals.created + ' created, ' +
                  totals.updated + ' updated) before this error.';
              }

              dialogService.showErrorDialog('Import Error', errorMessage);
            });
          });
      };

      // =====================================================
      // CANCEL
      // =====================================================

      vm.cancel = function () { $mdDialog.cancel(); };

    }
  ]);